import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetMenuServiceService {

  private apiUrl = environment.api; // Reemplaza con tu URL de la API

  constructor(private http: HttpClient) { }

  getMenuById(id: number, like: string = ''): Observable<any> {
    const url = `${this.apiUrl}/get_menu/${id},${like}`; // Reemplaza 'endpoint' con el nombre de tu endpoint

    return this.http.get(url);
  }
}
